/**
 * ADR-0013 — Sales Checkout Owner.
 *
 * Fachliche Grenze Verkaufsabschluss:
 * - Persistenz: infrastructure `persistCheckoutAtomically` (einziger Write-Pfad)
 * - Lot-Verbrauch: domain/inventory/consume
 * - Créances: domain/customers/balance (saleBalance) bei explizitem Kredit/Rest
 *
 * Events (Fakten): SaleCompleted → LotConsumed/StockChanged → CustomerBalanceChanged
 * UI darf keine parallele Checkout-Persistenz führen.
 */

import { resolveSaleUnpaidAmount } from '../../customers/balance/saleBalance';

export {
  resolveSaleUnpaidAmount,
  planCustomerBalanceDeltaFromSale,
  applyCustomerBalanceDelta
} from '../../customers/balance/saleBalance';

export {
  resolveSalePaidAmount,
  resolveSalePaidChannel,
  resolveSaleRegisterIncome,
  attachCreditSaleFields,
  attachMixedPaymentFields
} from './paymentAllocation';

/**
 * Fact-Payload für SaleCompleted (kein Befehl).
 * @param {object} sale
 * @param {object} [extras]
 */
export function buildSaleCompletedFact(sale, extras = {}) {
  return {
    type: 'sale_completed',
    sale,
    saleId: sale?.id || sale?.orderId || null,
    customerId: sale?.customerId || null,
    totalAmount: Number(sale?.totalAmount ?? sale?.total ?? 0) || 0,
    unpaidAmount: resolveSaleUnpaidAmount(sale),
    at: new Date().toISOString(),
    ...extras
  };
}
